import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../contexts/ApiContext";

export function useImageUpload(
  assetId: number,
  captureId: number,
  datapointId: number,
  surveyAssetName: string,
  panelAssetId?: number,
  callbacks?: {
    onError: (error: Response) => Promise<void>;
    onSuccess: () => void;
  },
) {
  const { utp2FilesAPIs } = useContext(ApiContext);
  return useMutation({
    ...callbacks,
    mutationKey: ["uploadImage"],
    mutationFn: async (file: File) => {
      return await utp2FilesAPIs.uploadImageFile(file, assetId, captureId, datapointId, surveyAssetName, panelAssetId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
